module.exports = __webpack_public_path__ + "img/running.72a33622.gif";